export { Truck as default } from './Truck';
